import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import parse from 'html-react-parser';

import classnames from 'classnames';

import { getFormatedDate } from '../../utils/date-utils';

import styles from './EventCard.module.scss';
import ICONS from '../../static/media/icons/icons-helper';
import Icon from '../Icon/Icon';
import EventCardCTAButton from '../event-card-cta-button/EventCardCTAButton';

const EventCard = ({
  event,
  onClick,
  containerStyle,
  linkButtonStyle,
  descriptionStyle,
  isLink,
}) => {
  const {
    name,
    state,
    description,
    shortDescription,
    startAt,
    endAt,
    link,
    ctas = [],
  } = event;

  const [isMounted, setIsMounted] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const renderHeaderDetails = () => {
    return (
      <div>
        {startAt && endAt && (
          <div className={styles.detailsWrapper}>
            <div className={styles.detailContainer}>
              {startAt && (
                <>
                  <p className={styles.label}>Starts:&nbsp;</p>
                  <p className={styles.detail}>
                    {getFormatedDate({ date: startAt })}
                  </p>
                </>
              )}
              {endAt && (
                <>
                  <p className={styles.label}>&nbsp;/&nbsp;</p>
                  <p className={styles.label}>Finishes:&nbsp;</p>
                  <p className={styles.detail}>
                    {getFormatedDate({ date: endAt })}
                  </p>
                </>
              )}
            </div>
          </div>
        )}
        {state && (
          <div className={styles.detailContainer}>
            <p className={styles.label}>Location:&nbsp;</p>
            <p className={styles.detail}>{state}</p>
          </div>
        )}
      </div>
    );
  };

  const renderDescriptionDetail = () => {
    const descriptionToShow = isLink ? shortDescription : parse(description);
    return (
      <div
        className={classnames(styles.descriptionContainer, descriptionStyle)}
      >
        <div>{descriptionToShow}</div>
        {!isLink && ctas.length > 0 && (
          <div className={styles.ctasContainer}>
            {ctas.map((cta) => (
              <EventCardCTAButton key={cta.title} {...cta} />
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderDetailLink = () => {
    return (
      <div>
        <a
          className={classnames(styles.link, linkButtonStyle)}
          href={link}
          target="_new"
        >
          LEARN MORE
          <img
            className={styles.arrowIcon}
            src={ICONS.RIGHT_ARROW}
            alt="icon-img"
          />
        </a>
      </div>
    );
  };

  const template = () => (
    <div>
      {!!name && <p className={styles.title}>{name.toUpperCase()}</p>}
      {!isLink && renderHeaderDetails()}
      {!!description && renderDescriptionDetail()}
      {!!link && renderDetailLink()}
    </div>
  );

  const handleOnClick = () => {
    if (isLink) {
      history.push(`/${event.menu.slug}/${event.slug}`);
      return;
    }

    onClick(event);
  };

  return (
    <div
      className={classnames(
        styles.container,
        containerStyle,
        isMounted && styles.fadeIn
      )}
      onClick={handleOnClick}
    >
      {isLink ? (
        <div className={styles.cardWrapper}>
          {template()}
          <div className={styles.linkContainer}>
            <Icon name="SIMPLE_ARROW" />
          </div>
        </div>
      ) : (
        template()
      )}
    </div>
  );
};

EventCard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    lat: PropTypes.number,
    lng: PropTypes.number,
    state: PropTypes.string,
    description: PropTypes.string,
    shortDescription: PropTypes.string,
    startAt: PropTypes.string,
    endAt: PropTypes.string,
    link: PropTypes.string,
    menu: PropTypes.object,
    slug: PropTypes.string,
    ctas: PropTypes.array,
  }).isRequired,
  onClick: PropTypes.func,
  containerStyle: PropTypes.string,
  linkButtonStyle: PropTypes.string,
  descriptionStyle: PropTypes.string,
  isLink: PropTypes.bool,
};

EventCard.defaultProps = {
  onClick: () => '',
  containerStyle: null,
  linkButtonStyle: null,
  descriptionStyle: null,
  isLink: false,
};

export default EventCard;
